import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PaygMessageDialogData {
  title: string;
  message: string;
  type: 'success' | 'error' | 'info';
}

@Component({
  selector: 'app-admin-payg-message-dialog',
  templateUrl: './admin-payg-message-dialog.component.html',
  styleUrl: './admin-payg-message-dialog.component.css',
  standalone: false
})
export class AdminPaygMessageDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AdminPaygMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PaygMessageDialogData
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}
